var map = {
	"./blog.yml": 52,
	"./cloud.yml": 53,
	"./color.yml": 54,
	"./country.yml": 55,
	"./doc.yml": 56,
	"./emoji.yml": 57,
	"./flag.yml": 58,
	"./git.yml": 59,
	"./icon.yml": 60,
	"./license.yml": 61,
	"./link.yml": 62,
	"./people.yml": 63,
	"./soft.yml": 64,
	"./src.yml": 65,
	"./status.yml": 66,
	"./taxonomy.yml": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;